module.exports = __webpack_public_path__ + "static/assets/7d7be73f034faa0b3da6189de002180c.svg";